import { HISTORY_FETCH_LIMIT } from 'containers/SubSidebar/AiImageContent/consts'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { aiImageThunks } from 'store/features/aiImage/thunks'
import { aiImageSelectors } from 'store/features/aiImage/selectors'
import { dispatch } from 'store'

export const useAiImageHistory = () => {
  const isHistoryLoading = useSelector(aiImageSelectors.isHistoryLoading)
  const historyItems = useSelector(aiImageSelectors.historyData) || []
  const historyDataLength = useSelector(aiImageSelectors.historyDataLength) || 0

  const hasData = historyDataLength > 0
  const isLoading = isHistoryLoading && !hasData

  //we fetch history data always on mount to have the latest history data
  //because image generation is async
  useEffect(() => {
    dispatch(
      aiImageThunks.getHistory({
        limit: HISTORY_FETCH_LIMIT
      })
    )
  }, [])

  return {
    historyItems,
    hasData,
    isLoading
  }
}
